
import React, { useState, useEffect } from 'react'
import { db } from './../../Firebase'
import { toPercent } from './../../addComas'




function Pobreza() {
    //Data
    const [data, setData] = useState(null)
    // Get data from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('FMI2').collection("componentePobreza").doc("data")
            .onSnapshot(snapshot => {
                setData(snapshot.data())
            }
            )
    }, [])
    return (
        <div className="paragraphs">
            {data && (
                <p>
                    La <strong>pobreza monetaria </strong>del país {data.pobMon.diff > 0 ? "aumento" : "se redujo"},
                 pasando de {String(data.pobMon.Past.Value).replace(".", ",")}% en {data.pobMon.Past.Year} a <strong>{String(data.pobMon.Actual.Value).replace(".", ",")}%* </strong>en {data.pobMon.Actual.Year}.
                </p>
            )}

        </div>
    )
}

export default Pobreza
